import React from 'react';
import { Button } from '../ui/button';
import { FUNDING_SEQUENCE_STRATEGY_TYPES } from '../../utils/funding/constants';

const formatCurrency = (value) => {
  if (value == null || value === '') return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(value);
};

const FundingSequenceGeneratePanel = ({
  client,
  matchCount = 0,
  strategyType,
  goalAmount,
  onStrategyTypeChange,
  onGoalAmountChange,
  onGenerate,
  onCreateManual,
  generating,
  saving,
}) => {
  if (!client) {
    return (
      <p className="text-sm text-[var(--fg-muted)]">
        Select a funding client to build a recommended application order.
      </p>
    );
  }

  return (
    <div className="space-y-4">
      <div className="grid gap-3 sm:grid-cols-2">
        <div className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2.5">
          <div className="text-[11px] font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Readiness tier</div>
          <div className="mt-1 text-sm text-[var(--fg-text)]">{client.readinessTier || 'Not scored'}</div>
        </div>
        <div className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2.5">
          <div className="text-[11px] font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Document status</div>
          <div className="mt-1 text-sm text-[var(--fg-text)]">{client.documentStatus || 'Missing'}</div>
        </div>
        <div className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2.5">
          <div className="text-[11px] font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Requested amount</div>
          <div className="mt-1 text-sm text-[var(--fg-text)]">{formatCurrency(client.requestedAmount)}</div>
        </div>
        <div className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2.5">
          <div className="text-[11px] font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Matched lenders</div>
          <div className="mt-1 text-sm text-[var(--fg-text)]">{matchCount}</div>
        </div>
      </div>

      <div className="grid gap-3 sm:grid-cols-2">
        <label className="block text-sm">
          <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Strategy type</span>
          <select
            value={strategyType}
            onChange={(event) => onStrategyTypeChange(event.target.value)}
            className="w-full rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2 text-sm text-[var(--fg-text)]"
          >
            {FUNDING_SEQUENCE_STRATEGY_TYPES.map((type) => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </label>
        <label className="block text-sm">
          <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Goal amount</span>
          <input
            type="number"
            value={goalAmount ?? ''}
            onChange={(event) => onGoalAmountChange(event.target.value)}
            placeholder={client.requestedAmount ? String(client.requestedAmount) : '100000'}
            className="w-full rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2 text-sm text-[var(--fg-text)]"
          />
        </label>
      </div>

      <div className="flex flex-wrap gap-2">
        <Button
          className="rounded-xl bg-[var(--fg-accent)] hover:bg-[#126b4f]"
          onClick={onGenerate}
          disabled={generating || matchCount === 0}
          data-testid="funding-sequence-generate"
        >
          {generating ? 'Generating...' : 'Generate Sequence'}
        </Button>
        <Button
          variant="outline"
          className="rounded-xl"
          onClick={onCreateManual}
          disabled={saving}
        >
          {saving ? 'Creating...' : 'Create Manual Sequence'}
        </Button>
      </div>
      {matchCount === 0 ? (
        <p className="text-xs text-[var(--fg-muted)]">Run Bank Match first to generate a recommended application order.</p>
      ) : null}
    </div>
  );
};

export default FundingSequenceGeneratePanel;
